export default "__VITE_ASSET__CVUfvDG___"